<template lang="pug">
#validacao-termo-compromisso
    .linha
        .coluna
            title-component(label='Verificar Autenticidade do Termo de Compromisso')
    .linha
        .coluna            
            .text-subtitle Informe o número do CAR ou do PRADA ou do Termo de Compromisso:
    .linha
        .coluna-2
            .select-text-component 
                select-filter-component(
                    ref='selectTipoNumero'
                    :list='tipoNumeroList'
                    label='label'
                    fieldLabel='Tipo de Número:'
                    placeholder='Selecione'
                    :filterable='true'
                    @change='selecionarTipoNumero'
)    

        .coluna-5
            .input-text-component
                input.input-text(
                    type="text"
                    v-model="numeroDocumento"
                    :maxlength="maxLengthDocumento"
                    @input="formatarNumeroDocumento"
                    :placeholder= "tipoNumeroPlaceHolder"
                )

        .coluna-3
            .linha
                .search-button-component 
                    button-component(
                        label='Consultar',
                        icon='mdi-text-box-search-outline',
                        :disabled='isLoading',
                        @click.native="pesquisar()"
                )                

                .search-button-component 
                    button-component(
                        label='Limpar',
                        icon='mdi-filter-remove',
                        :disabled='isLoading',
                        @click.native="limpar()"
                )


    div.documento-invalido(v-if='msgErro') {{msgErro}}                        

    .linha(v-if='assinaturasInformacoes?.termoCompromissoAssinado === true')
        TermoCompromissoAssinaturaComponent(:assinaturasInformacoes='assinaturasInformacoes')
    
        
    
    
    
    
</template>

<script>
import { validarTermoCompromisso } from '@/services/termoCompromisso.service';
import TermoCompromissoAssinaturaComponent from '@/views/termoCompromisso/components/TermoCompromissoAssinaturaComponent.vue';

export default {
    name: 'TermoCompromissoValidacao',

    components: {
        TermoCompromissoAssinaturaComponent,
    },

    data() {
        return {
            numeroDocumento: null,
            isLoading: false,
            tipoNumeroPlaceHolder: null,
            assinaturasInformacoes: null,
            msgErro: null,
            maxLengthDocumento: null,
            tipoNumeroList: [
                { id: 4, label: 'TCA' },
                { id: 1, label: 'TCPRA' },
                { id: 2, label: 'CAR' },
                { id: 3, label: 'PRADA' }
            ],
        };
    },

    async mounted() { },

    methods: {
        async pesquisar() {
            this.isLoading = true;
            this.msgErro = null;
            this.assinaturasInformacoes = null;
            if (!this.tipoNumero) {
                this.msgErro = 'Tipo de documento não informado!';
            } else {

                if (!this.numeroDocumento || (this.numeroDocumento && this.numeroDocumento.length !== this.maxLengthDocumento)) {
                    this.msgErro = 'Número informado é inválido!';                    
                } else {
                    try {
                        this.assinaturasInformacoes = await validarTermoCompromisso(this.tipoNumero, this.numeroDocumento.replace('/', '*'));
                        if (!this.assinaturasInformacoes) {
                            this.msgErro = 'Termo de compromisso não encontrado.';
                        }
                        if (this.assinaturasInformacoes.termoCompromissoAssinado === false) {
                            this.msgErro = 'Termo de compromisso pendente de assinatura.';
                        }
                    } catch {
                        this.msgErro = 'Problema ao consultar o número informado. Tente mais tarde.';
                        this.isLoading = false;
                    }
                }

            }
            this.isLoading = false;
        },
        formatarNumeroDocumento() {
            this.msgErro = null;

            if (this.tipoNumero === 1) {
                let doc = this.numeroDocumento.replace(/\D/g, '').replace('TCPRA-', '').replace('SP-', '').replace('PRADA-', '');
                this.numeroDocumento = 'TCPRA-' + doc.replace(/(\d{6})/, '$1');
            }

            if (this.tipoNumero === 2) {
                let doc = this.numeroDocumento.replace('TCPRA-', '').replace('SP-', '').replace('PRADA-', '');
                this.numeroDocumento = 'SP-' + doc.replace(/(\w{7})(\w{32})/, '$1-$2');
            }

            if (this.tipoNumero === 3) {
                let doc = this.numeroDocumento.replace(/\D/g, '').replace('TCPRA-', '').replace('SP-', '').replace('PRADA-', '');
                this.numeroDocumento = 'PRADA-' + doc.replace(/(\d{6})(\d{4})(\d{2})/, '$1/$2-$3');
            }

            if (this.tipoNumero === 4) {
                let doc = this.numeroDocumento.replace(/\D/g, '').replace('TCPRA-', '').replace('SP-', '').replace('PRADA-', '');
                this.numeroDocumento = 'TCA-' + doc.replace(/(\d{6})/, '$1');
            }

        },
        limpar() {
            this.msgErro = null;
            this.$refs.selectTipoNumero.itemSelecionado = '';
            this.numeroDocumento = null;
            this.maxLengthDocumento = null;
            this.tipoNumeroPlaceHolder = null;
            this.assinaturasInformacoes = null;
        },
        selecionarTipoNumero(tipoNumero) {
            this.msgErro = null;
            this.numeroDocumento = null;
            this.tipoNumero = tipoNumero;

            if (this.tipoNumero === 1) {
                this.maxLengthDocumento = 12;
                this.tipoNumeroPlaceHolder = 'TCPRA-______';
            }

            if (this.tipoNumero === 2) {
                this.maxLengthDocumento = 43;
                this.tipoNumeroPlaceHolder = 'SP-_______-________________________________';
            }

            if (this.tipoNumero === 3) {
                this.maxLengthDocumento = 20;
                this.tipoNumeroPlaceHolder = 'PRADA-______/____-__';
            }

            if (this.tipoNumero === 4) {
                this.maxLengthDocumento = 10;
                this.tipoNumeroPlaceHolder = 'TCA-______';
            }

        }
    },
};
</script>
<style lang="scss" scoped>

.text-subtitle {
    color: black;
    font-size: 20px;
    margin-left: 5px;
}

.select-text-component {
    margin-bottom: 15px;
    margin-left: 5px;
}

.input-text-component {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    display: flex;
    margin-bottom: 5px;
}

.search-button-component {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 40%;
    padding-left: 10px;
    display: flex;
}

.input-text {
    padding: 0px 8px;
    margin: 5px 0 10px 8px;
    height: 26px;
    border: 2px solid var(--primary-light-green) !important;
    border-radius: 5px;
}

.input-text.--error {
    border: 2px solid var(--primary-light-red) !important;
}

.input-text:focus-visible {
    border: 2px solid var(--primary-green) !important;
    border-radius: 5px;
    outline: none;
}

.input-text:focus-visible.--error {
    border: 2px solid var(--primary-red) !important;
}

.documento-invalido {
    margin-left: 10px;
    margin-top: -10px;
    font-size: 16px;
    color: var(--primary-light-red);
}
</style>
